import { render } from "./CooperationView.vue?vue&type=template&id=5e07162a"
import script from "./CooperationView.vue?vue&type=script&lang=js"
export * from "./CooperationView.vue?vue&type=script&lang=js"

import "./CooperationView.vue?vue&type=style&index=0&id=5e07162a&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__